__turbopack_context__.v({
  "image": "ffdCcq_image",
  "title": "ffdCcq_title",
  "trustIcons": "ffdCcq_trustIcons",
  "trustIconsContainer": "ffdCcq_trustIconsContainer",
});
